export const PLANS = ['free_trial', 'standard', 'free'] as const;
export type Plan = (typeof PLANS)[number];

export const PAYMENT_STATUSES = ['active', 'inactive', 'cancelled', 'pending'] as const;
export type PaymentStatus = (typeof PAYMENT_STATUSES)[number];

/** Length of the free trial granted at sign-up. */
export const TRIAL_DAYS = 45;

export const LANGUAGES = ['pt', 'en'] as const;
export type Language = (typeof LANGUAGES)[number];

export const GRID_SIZES = [4, 6, 8] as const;
export type GridSize = (typeof GRID_SIZES)[number];

/** Limits applied to personalised data, validated on both client and server. */
export const LIMITS = {
  maxCategories: 100,
  maxSymbols: 1000,
  /** Symbols remembered for the "Frequentes" screen (least used are dropped). */
  maxUsageEntries: 500,
  /** Hidden symbols / categories ("Ocultar"), counting built-in and personalised ones. */
  maxHiddenSymbols: 1200,
  maxHiddenCategories: 120,
  /** Visual routines ("Rotina"). */
  maxRoutines: 20,
  maxRoutineSteps: 12,
  maxRoutineNameLength: 40,
  maxLabelLength: 60,
  maxCategoryNameLength: 40,
  /** Max length of a data: URL for an uploaded image (~260 KB of binary data). */
  maxImageDataUrlLength: 350_000,
  /** Largest side, in pixels, of an uploaded image after client-side compression. */
  imageMaxDimension: 512,
  /** Largest original file accepted before compression. */
  maxUploadBytes: 15 * 1024 * 1024,
  minPasswordLength: 8,
  maxPasswordLength: 128,
} as const;

export const PIN_MAX_ATTEMPTS = 5;
export const PIN_LOCK_MINUTES = 15;
/** How long a successful PIN check unlocks the profile page. */
export const PIN_UNLOCK_MINUTES = 10;
